<div class="h-h">
  <div>
    <mn-svg
      data-ui-sound
      mnClickArea
      class="c-p cu-p"
      name="arrow"
      mnAnalyticsClick="back_sidebar_provably_fair"
      (click)="close($event, true)" />
    <b class="t-h u-c">{{ "provably-fair.title" | mnTranslate }}</b>
  </div>
  <mn-button aEvent="provably_fair_close" (clicked)="close($event, false)">
    <mn-svg name="close" />
  </mn-button>
</div>
<div class="f-c g-16 o-y-a">
  <span class="t-s c-se">{{ "provably-fair.your-next-seed" | mnTranslate }}</span>
  <mn-text
    aEvent="client_seed"
    [validators]="validators"
    [max]="max"
    [value]="seed()"
    (focused)="focused($event)"
    (saved)="save($event)"
    (valueChange)="seed.set($event)" />
  <mn-button aEvent="provably_fair_info" size="large" type="transparent" (clicked)="info()">
    <b class="t-r u-c">{{ "provably-fair.what-is" | mnTranslate }}</b>
    <mn-svg name="question" />
  </mn-button>
</div>
